<script>
import Layout from '@/router/layouts/auth'
import responsive from '@/mixin/responsive'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import appConfig from '@/app.config'
import { getSmsClient } from '@/services/sms'
import { workOrderTypesOdoo } from '../lib/workOrderTypesOdoo'
const vsmsSmsAxios = getSmsClient()
moment.locale('id')

export default {
  mixins: [Helper, responsive],
  page: {
    title: 'Dashboard',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
  },

  computed: {
    title() {
      return this.$t('workOrder.dashboard.title')
    },
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.workOrder.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.workOrder
      }
    },
    workOrder() {
      return [
        {
          key: 'planned_at',
          label: this.$t('workTime.column.planDate'),
          sortable: true,
        },
        {
          key: 'user_name',
          label: this.$t('workOrder.table.technician'),
          sortable: true,
        },
        {
          key: 'wo_number',
          label: `${this.$t('workOrder.table.woNumber')} | ${this.$t('workOrder.table.service')}`,
          sortable: true,
        },
        {
          key: 'company_name',
          label: this.$t('workOrder.table.customer'),
          sortable: true,
        },
        {
          key: 'log_in',
          label: `${this.$t('workOrder.table.clockIn')} - ${this.$t(
            'workOrder.table.startProcess'
          )}`,
          sortable: true,
        },
        {
          key: 'log_out',
          label: `${this.$t('workOrder.table.clockOut')} - ${this.$t(
            'workOrder.table.endProcess'
          )}`,
          sortable: true,
        },
        {
          key: 'license_plate',
          label: this.$t('workOrder.table.licensePlate'),
          sortable: true,
        },
        {
          key: 'process',
          label: this.$t('workOrder.table.status'),
          sortable: true,
        },
      ]
    },
    rows() {
      return this.workOrders.length
    },
  },

  methods: {
    async getWorkOrderList() {
      this.loading = true
      const qp = {
        filters: `startedOn:eq:${moment().format('YYYY-MM-DD')}`,
      }
      const workOrderList = await vsmsSmsAxios
        .get(`/work-order/dashboard`, { params: qp })
        .catch((error) => {
          this.handleError(error)
        })

      if (!workOrderList?.data?.data) {
        this.loading = false
        return
      }

      this.workOrders = workOrderList.data.data
      this.filteredItems = workOrderList.data.data
      this.totalRows = workOrderList.data.data.length

      this.loading = false
    },

    getWoType(code) {
      return workOrderTypesOdoo().find((map) => map.code === code)?.name
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data
        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },
  },

  data() {
    return {
      workOrders: [],
      filter: null,
      isSort: false,
      filteredItems: [],
      loading: false,
    }
  },

  mounted() {
    setInterval(this.getWorkOrderList(), 5 * 60 * 1000)
  },
}
</script>
<template>
  <Layout>
    <div style="height: 100vh; overflow: hidden">
      <div class="text-center pt-3">
        <h1 class="mb-2">
          <strong>{{ title }}</strong>
        </h1>
      </div>
      <div class="card mc-card mc-card-front">
        <div class="card-body">
          <div>
            <b-row>
              <b-col lg="12">
                <div class="row my-2">
                  <div class="col-lg-12">
                    {{ $t('global.show') }}
                    <strong>{{ filteredItems.length }}</strong>
                    {{ `${$t('workOrder.title')} ${$t('global.today')}` }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table-simple
            table-class="w-100"
            bordered
            responsive
            style="height: calc(100vh - 70px); padding-bottom: 100px; box-sizing: border-box"
          >
            <b-thead>
              <b-th
                style="text-align: center; word-wrap: break-word"
                v-for="(field, i) in visibleFields"
                :key="i"
              >
                {{ field.label }}
              </b-th>
            </b-thead>
            <b-tbody>
              <template v-for="workOrder in workOrders">
                <!-- kalau process true -->
                <template v-if="workOrder.process">
                  <b-tr
                    v-for="(tasks, index) in workOrder.process"
                    :key="workOrder.wo_number + index"
                  >
                    <template v-if="workOrder.process.length > 1">
                      <template v-if="index === 0">
                        <b-td
                          :rowspan="workOrder.process.length"
                          style="text-align: center; vertical-align: middle"
                        >
                          {{ momentDMHms(workOrder.planned_at) }}
                        </b-td>
                        <b-td
                          :rowspan="workOrder.process.length"
                          style="text-align: center; vertical-align: middle"
                        >
                          {{ workOrder.user_name }}
                        </b-td>
                        <b-td
                          :rowspan="workOrder.process.length"
                          style="text-align: justify; vertical-align: middle"
                        >
                          <strong>{{ `${$t('workOrder.table.woNumber')}: ` }} </strong>
                          {{ workOrder.wo_number }}<br />
                          <strong>{{ `${$t('workOrder.table.woType')}: ` }} </strong>
                          {{ getWoType(workOrder.wo_type_erp) }}<br />
                          <strong>{{ `${$t('workOrder.table.installationPlan')}: ` }}</strong>
                          {{ workOrder.quantity_plan }}<br />
                          <strong>{{ `${$t('workOrder.table.actualInstall')}: ` }}</strong>
                          {{ workOrder.actual_installation }}
                        </b-td>
                        <b-td
                          :rowspan="workOrder.process.length"
                          style="text-align: center; vertical-align: middle"
                        >
                          {{ workOrder.company_name }}
                        </b-td>
                        <b-td
                          :rowspan="workOrder.process.length"
                          style="text-align: center; vertical-align: middle"
                        >
                          {{ workOrder.log_in ? momentDMHms(workOrder.log_in) : '-' }}
                        </b-td>
                        <b-td
                          :rowspan="workOrder.process.length"
                          style="text-align: center; vertical-align: middle"
                        >
                          {{ workOrder.log_out ? momentDMHms(workOrder.log_out) : '-' }}
                        </b-td>
                        <b-td style="text-align: center; vertical-align: middle">
                          <template v-if="workOrder.wo_type_erp === 'move'">
                            <template v-if="tasks.license_plate">
                              <strong>{{ `${$t('workOrder.dashboard.from')}: ` }}</strong>
                              {{ tasks.license_plate }}<br />
                            </template>
                            <template v-if="tasks.target_vehicle_id && tasks.target_vehicle">
                              <strong>{{ `${$t('workOrder.dashboard.to')}: ` }}</strong>
                              {{ tasks.target_vehicle.license_plate }}
                            </template>
                            <template v-if="!tasks.license_plate && !tasks.target_vehicle_id">
                              -
                            </template>
                          </template>
                          <template v-else>
                            {{ tasks.license_plate || '-' }}
                          </template>
                        </b-td>
                        <b-td style="text-align: center; vertical-align: middle">
                          <b-badge v-if="tasks.tasks_status === 'V'" class="bg-success text-white">
                            {{ $t('workOrder.table.done') }}
                          </b-badge>
                          <b-badge v-else class="bg-primary text-white">
                            {{ $t('workOrder.table.process') }}
                          </b-badge>
                        </b-td>
                      </template>
                      <template v-else>
                        <b-td style="text-align: center; vertical-align: middle">
                          <template v-if="workOrder.wo_type_erp === 'move'">
                            <template v-if="tasks.license_plate">
                              <strong>{{ `${$t('workOrder.dashboard.from')}: ` }}</strong>
                              {{ tasks.license_plate }}<br />
                            </template>
                            <template v-if="tasks.target_vehicle_id && tasks.target_vehicle">
                              <strong>{{ `${$t('workOrder.dashboard.to')}: ` }}</strong>
                              {{ tasks.target_vehicle.license_plate }}
                            </template>
                            <template v-if="!tasks.license_plate && !tasks.target_vehicle_id">
                              -
                            </template>
                          </template>

                          <template v-else>
                            {{ tasks.license_plate || '-' }}
                          </template>
                        </b-td>
                        <b-td style="text-align: center; vertical-align: middle">
                          <b-badge v-if="tasks.tasks_status === 'V'" class="bg-success text-white">
                            {{ $t('workOrder.table.done') }}
                          </b-badge>
                          <b-badge v-else class="bg-primary text-white">
                            {{ $t('workOrder.table.process') }}
                          </b-badge>
                        </b-td>
                      </template>
                    </template>
                    <template v-else>
                      <b-td style="text-align: center; vertical-align: middle">
                        {{ momentDMHms(workOrder.planned_at) }}
                      </b-td>
                      <b-td style="text-align: center; vertical-align: middle">
                        {{ workOrder.user_name }}
                      </b-td>
                      <b-td style="text-align: justify; vertical-align: middle">
                        <strong>{{ `${$t('workOrder.table.woNumber')}: ` }} </strong>
                        {{ workOrder.wo_number }}<br />
                        <strong>{{ `${$t('workOrder.table.woType')}: ` }} </strong>
                        {{ getWoType(workOrder.wo_type_erp) }}<br />
                        <strong>{{ `${$t('workOrder.table.installationPlan')}: ` }}</strong>
                        {{ workOrder.quantity_plan }}<br />
                        <strong>{{ `${$t('workOrder.table.actualInstall')}: ` }}</strong>
                        {{ workOrder.actual_installation }}
                      </b-td>
                      <b-td style="text-align: center; vertical-align: middle">
                        {{ workOrder.company_name }}
                      </b-td>
                      <b-td style="text-align: center; vertical-align: middle">
                        {{ workOrder.log_in ? momentDMHms(workOrder.log_in) : '-' }}
                      </b-td>
                      <b-td style="text-align: center; vertical-align: middle">
                        {{ workOrder.log_out ? momentDMHms(workOrder.log_out) : '-' }}
                      </b-td>
                      <b-td style="text-align: center; vertical-align: middle">
                        <template v-if="workOrder.wo_type_erp === 'move'">
                          <template v-if="tasks.license_plate">
                            <strong>{{ `${$t('workOrder.dashboard.from')}: ` }}</strong>
                            {{ tasks.license_plate }}<br />
                          </template>
                          <template v-if="tasks.target_vehicle_id && tasks.target_vehicle">
                            <strong>{{ `${$t('workOrder.dashboard.to')}: ` }}</strong>
                            {{ tasks.target_vehicle.license_plate }}
                          </template>
                          <template v-if="!tasks.license_plate && !tasks.target_vehicle_id">
                            -
                          </template>
                        </template>
                        <template v-else>
                          {{ tasks.license_plate || '-' }}
                        </template>
                      </b-td>
                      <b-td style="text-align: center; vertical-align: middle">
                        <template v-if="tasks.tasks_status">
                          <b-badge v-if="tasks.tasks_status === 'V'" class="bg-success text-white">
                            {{ $t('workOrder.table.done') }}
                          </b-badge>
                          <b-badge v-else class="bg-primary text-white">
                            {{ $t('workOrder.table.process') }}
                          </b-badge>
                        </template>
                        <template v-else> {{ '-' }} </template>
                      </b-td>
                    </template>
                  </b-tr>
                </template>
                <!-- kalau process false -->
                <template v-else>
                  <b-tr :key="workOrder.wo_number">
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ momentDMHms(workOrder.planned_at) }}
                    </b-td>
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ workOrder.user_name }}
                    </b-td>
                    <b-td style="text-align: justify; vertical-align: middle">
                      <strong>{{ `${$t('workOrder.table.woNumber')}: ` }} </strong>
                      {{ workOrder.wo_number }}<br />
                      <strong>{{ `${$t('workOrder.table.woType')}: ` }} </strong>
                      {{ getWoType(workOrder.wo_type_erp) }}<br />
                      <strong>{{ `${$t('workOrder.table.installationPlan')}: ` }}</strong>
                      {{ workOrder.quantity_plan }}<br />
                      <strong>{{ `${$t('workOrder.table.actualInstall')}: ` }}</strong>
                      {{ workOrder.actual_installation }}
                    </b-td>
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ workOrder.company_name }}
                    </b-td>
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ workOrder.log_in ? momentDMHms(workOrder.log_in) : '-' }}
                    </b-td>
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ workOrder.log_out ? momentDMHms(workOrder.log_out) : '-' }}
                    </b-td>
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ '-' }}
                    </b-td>
                    <b-td style="text-align: center; vertical-align: middle">
                      {{ '-' }}
                    </b-td>
                  </b-tr>
                </template>
              </template>
            </b-tbody>
          </b-table-simple>
        </div>
        <div
          class="mc-liveview--temp-footer py-4 clearfix p-5"
          style="
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            margin-top: auto;
            background-color: white;
          "
        >
          <figure class="float-start mb-0">
            <img src="@/assets/images/vsms-small.png" alt />
          </figure>
          <div class="float-end">
            <span class="me-3">{{ $t('global.poweredBy') }}:</span>
            <figure class="d-inline-block mb-0">
              <img src="@/assets/images/mceasy.png" alt />
            </figure>
          </div>
          <p class="text-center mb-0">
            {{ $t('global.total') }} <strong>{{ filteredItems.length }}</strong>
            {{ $t('workOrder.title') }}
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
